<template>
  <div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="560"
      :value="showDialog"
      persistent
      scrollable
      content-class="cart-dialog-shell"
    >
      <v-card flat class="cart-dialog">
        <div class="cart-header">
          <h2 class="cart-title">Tu pedido</h2>
          <v-btn
            v-if="getTotalItems > 0"
            text
            color="error"
            class="cart-vaciar"
            :ripple="false"
            @click="confirmVaciar = true"
          >
            <v-icon left small>mdi-delete-outline</v-icon>
            Vaciar
          </v-btn>
        </div>

        <v-card-text class="cart-body">
          <cart-details v-if="showDialog"></cart-details>

          <div v-if="getTotalItems > 0" class="cart-subtotal">
            <span>Subtotal</span>
            <strong>${{ formattedTotal }}</strong>
          </div>

          <cart-suggestions
            v-if="showDialog && getTotalItems > 0"
            @navigate="cerrar"
          />

          <v-btn
            v-if="getTotalItems > 0 && $route.name !== 'Checkout'"
            block
            outlined
            color="primary"
            class="cart-btn-secondary mt-3"
            @click="seguirComprando"
          >
            Agregar más productos
          </v-btn>
        </v-card-text>

        <v-card-actions class="cart-actions">
          <v-btn
            class="cart-btn-close"
            color="primary"
            outlined
            @click="cerrar"
          >
            Cerrar
          </v-btn>
          <v-btn
            v-if="$route.name !== 'Checkout' && !(data && data.NegocioCerrado)"
            class="cart-btn-buy"
            color="primary"
            dark
            :disabled="getTotalItems === 0"
            @click.prevent="irACheckout"
          >
            Comprar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmVaciar" max-width="360" persistent>
      <v-card class="pa-2">
        <v-card-title class="text-h6">Vaciar carrito</v-card-title>
        <v-card-text>
          ¿Querés quitar todos los productos de tu pedido?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="confirmVaciar = false">Cancelar</v-btn>
          <v-btn color="error" dark @click="vaciarCarrito">Vaciar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CartDetails from './CartDetails.vue'
import CartSuggestions from './CartSuggestions.vue'
import { bus } from '@/helpers/bus.js'

export default {
  components: { CartDetails, CartSuggestions },
  name: 'CartDialog',
  mounted () {
    this._onVerCarrito = () => { this.showDialogEvent = true }
    bus.$on('ver-carrito', this._onVerCarrito)
  },
  beforeDestroy () {
    if (this._onVerCarrito) bus.$off('ver-carrito', this._onVerCarrito)
  },
  data () {
    return {
      showDialogEvent: false,
      confirmVaciar: false
    }
  },
  computed: {
    ...mapGetters('Carrito', ['getTotalItems', 'getTotal']),
    ...mapGetters('App', ['data']),
    showDialog () {
      return this.isOpen || this.showDialogEvent
    },
    formattedTotal () {
      return (Number(this.getTotal) || 0).toLocaleString('es-AR')
    }
  },
  props: {
    isOpen: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    ...mapActions('Carrito', ['resetCarrito']),
    cerrar () {
      this.showDialogEvent = false
      this.$emit('update:isOpen', false)
    },
    irACheckout () {
      this.cerrar()
      this.$router.push({ name: 'Checkout' })
    },
    seguirComprando () {
      this.cerrar()
      const client = this.$route.params.client || this.$clientCode()
      if (this.$route.name === 'Home' || this.$route.name === 'HomeShort' || this.$route.name === 'ProductosMobile') {
        return
      }
      this.$router.push({ name: 'Home', params: { client } }).catch(() => {})
    },
    vaciarCarrito () {
      this.resetCarrito()
      this.confirmVaciar = false
    }
  }
}
</script>

<style>
.cart-dialog-shell {
  border-radius: 18px 18px 0 0 !important;
  overflow: hidden;
}
</style>

<style scoped>
.cart-dialog {
  display: flex;
  flex-direction: column;
  max-height: min(92vh, 760px);
  background: #fafafa;
}
.cart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 18px 8px;
  background: #fff;
}
.cart-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.87);
}
.cart-vaciar {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600;
}
.cart-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 8px 18px 16px !important;
  background: #fff;
}
.cart-subtotal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding: 14px 0 6px;
  border-top: 1px solid #ececec;
  font-size: 1rem;
}
.cart-subtotal strong {
  font-size: 1.1rem;
}
.cart-actions {
  display: flex;
  gap: 10px;
  padding: 12px 16px 16px !important;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}
.cart-btn-close,
.cart-btn-buy,
.cart-btn-secondary {
  flex: 1;
  height: 44px !important;
  border-radius: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  font-weight: 700 !important;
}
.cart-btn-close {
  background: #fff !important;
}
.cart-btn-buy {
  color: #fff !important;
}
</style>
